// Faithful port of eb-ui `packages/eds/eds-share-box/src/LinkedinShare.jsx`.
// ShareBox always forces `staticUrl=true` for LinkedIn (see ShareBox.tsx),
// but the dynamic shareArticle branch is ported too — it's reachable when the
// component is used directly.
import React from 'react';
import { formatUrl } from 'url-lib';
import { IconButton } from '@eventbrite/legacy-eds.icon-button';
import { LogoLinkedin } from '@eventbrite/legacy-eds.iconography';
import { gettext } from '../../i18n/gettext';
import { openUrl, WindowSettings } from './utils';
import type { BaseShareProps, UtmOptions } from './types';

export const STATIC_LINKEDIN_URL =
    '/organizations/marketing/share-on-social/integrations/linkedin';

export const STATIC_SETTINGS: WindowSettings = {
    name: '_blank',
    noPopup: true,
};

const _getEventUrl = (eventUrl: string, utmOptions: UtmOptions | undefined) =>
    formatUrl(eventUrl, {
        aff: 'esli',
        ...utmOptions,
    });

export interface LinkedinShareProps extends BaseShareProps {
    /**
     * Default is false. If true, LinkedIn button will lead to
     * <host>/STATIC_LINKEDIN_URL; otherwise it generates a dynamic url for
     * sharing specific content on LinkedIn.
     */
    staticUrl?: boolean;
}

export default class LinkedinShare extends React.Component<LinkedinShareProps> {
    _handleButtonClick() {
        const { eventUrl, onClick, staticUrl = false, utmOptions } = this.props;

        if (onClick) {
            onClick();
        }

        if (staticUrl) {
            openUrl(STATIC_LINKEDIN_URL, STATIC_SETTINGS);
        } else {
            const url = formatUrl('https://www.linkedin.com/shareArticle', {
                url: _getEventUrl(eventUrl, utmOptions),
            });

            openUrl(url);
        }
    }

    render() {
        return (
            <span
                className="eds-l-pad-right-1"
                data-spec="linkedin-share-box-container"
                data-heap-id={this.props.dataHeapId}
                data-share-method={this.props.shareMethod}
                data-page-area={this.props.dataPageArea}
                data-event-id={this.props.eventId}
            >
                <IconButton
                    onClick={this._handleButtonClick.bind(this)}
                    iconType={<LogoLinkedin />}
                    title={gettext('Share on Linkedin')}
                />
            </span>
        );
    }
}
